import { Integer } from "@type-r/ext-types";
import { attributes, AttributesMixin, define, memberOf, Model } from "@type-r/models";
import { asCurrency } from "lqx-react/lib";
import { CompanyModel, globalStore, PlatformCompany } from "api";
import { matchString } from "api/common";
import { fetchJson, restfulIO } from "api/endpoint";
import { root } from "../api/common";

@define
export class CustomerDebth extends Model {
    static endpoint = restfulIO( root + 'invoice/customer-debths' );
    
    static attributes = {
        customer : memberOf( globalStore.platformCompanies, PlatformCompany ),
        supplier : memberOf( globalStore.platformCompanies, PlatformCompany ),
        outstandingAmount : Number,
        invoicedAmount : Number,
        count : Integer,
        overdueCount : Integer,
        overdueAmount: Number,
        promisedAmount: Number,
        disputedAmount: Number,
        currency: String,
    }

    get customerName() {
        return this.customer ? this.customer.name : '';
    }

    get outstandingAmountOrInvoiceAmount() {
        return Boolean(this.outstandingAmount) ? this.outstandingAmount : this.invoicedAmount
    }

    filter(text, filteredByInvoiceNumber) {
        return !text 
            || (this.customer && matchString(this.customer.name, text)) 
            || matchString(String(this.outstandingAmount), text)
            || matchString(asCurrency(this.outstandingAmount), text)
            || filteredByInvoiceNumber.some(cd => this.customer && cd.customer === this.customer.id);
    }

    static async search(params) {
        const url = `${this.endpoint.url}?${new URLSearchParams(params).toString()}`;

        return await fetchJson('GET', url);
    }
}
export interface CustomerDebth extends AttributesMixin<typeof CustomerDebth>{}


export const AggregateDebth = attributes({
    invoicedAmount : 0,
    outstandingAmount : 0,
    count : Integer,
    currency : String,
})

@define
export class DebthSummary extends Model {
    static endpoint = restfulIO( root + 'invoice/aggregate-debths' );

    static attributes = {
        all : AggregateDebth,
        alldue : AggregateDebth,
        day1 : AggregateDebth,
        day6 : AggregateDebth,
        past5days : AggregateDebth,
        past30days : AggregateDebth,
        past60days : AggregateDebth,
        past60plusdays : AggregateDebth,
    }
}

export interface DebthSummary extends AttributesMixin<typeof DebthSummary>{}

@define
export class DebthByCategory extends Model {
    static endpoint = restfulIO( root + 'invoice/debths-by-category' );

    static attributes = {
        all : AggregateDebth,
        new : AggregateDebth,
        promised : AggregateDebth,
        withRA : AggregateDebth,
        matched : AggregateDebth,
        reconciled : AggregateDebth
    }
}

export interface DebthByCategory extends AttributesMixin<typeof DebthByCategory>{}

